import { createUseStyles } from 'react-jss'
import { WHITE_83 } from '@styles/colors'

export default createUseStyles({
  section: {
    '@media (min-width: 1024px)': {
      paddingTop: '9rem',
      paddingBottom: '9rem',
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
      width: '100%'
    },
    backgroundColor: 'var(--secondary__page__background__color)',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    width: '100%'
  },
  container: {
    flexGrow: 1,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    width: 'auto'
  },
  columns: {
    '&:not(:last-child)': {
      marginBottom: 'calc(1.5rem - 0.75rem)'
    },
    '@media (max-width: 700px)': {
      display: 'block'
    },
    display: 'flex',
    marginLeft: '-0.75rem',
    marginRight: '-0.75rem',
    marginTop: '-0.75rem',
    alignItems: 'center'
  },
  column: {
    display: 'block',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 1,
    padding: '0.75rem',
    textAlign: 'center !important',
    '& img': {
      backgroundColor: WHITE_83,
      borderRadius: '5px',
      marginTop: '20px'
    }
  },
  title: {
    color: 'var(--title__text__color)',
    fontSize: '2rem',
    marginBottom: '1.5rem',
    fontWeight: 'bold',
    lineHeight: '1.125',
    wordBreak: 'break-word'
  },
  subTitle: {
    marginTop: '-1.25rem',
    color: 'var(--body__text__color)',
    fontSize: '1.25rem',
    fontWeight: 400,
    lineHeight: '1.25',
    wordBreak: 'break-word'
  }
})
